/**
 * Pure helpers for 404 / offline status screens (plan 4 R11).
 */

/** @param {string|null|undefined} productId */
export function dashboardHref(productId) {
  if (!productId) return '/app/dashboard';
  return `/app/dashboard?product_id=${encodeURIComponent(productId)}`;
}

/**
 * Copy for the not-found page.
 * @param {string|null|undefined} path
 */
export function notFoundCopy(path) {
  const clean = String(path || '').trim();
  return {
    kicker: '404',
    title: 'Page not found',
    body: clean
      ? ('"' + clean + '" is not part of Bonnie yet.')
      : 'That address is not part of Bonnie yet.',
    actionLabel: 'Back to dashboard',
  };
}

/** Copy for the offline page. */
export function offlineCopy() {
  return {
    kicker: 'Offline',
    title: "You're offline",
    body: 'Your connection has been lost. Some data may not be up to date until you are back online.',
    retryLabel: 'Retry',
    homeLabel: 'Go to dashboard',
    note: 'Previously loaded pages may still be available until you refresh.',
  };
}

/**
 * Whether the browser reports an online connection.
 * @param {{ onLine?: boolean }|null|undefined} nav
 */
export function isOnline(nav) {
  if (!nav || typeof nav.onLine !== 'boolean') return true;
  return nav.onLine;
}
